import DetailVM from './detail-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init : function(element) {
    let vm = new Vue(DetailVM);
    vm.bindData(JSON.parse(element.dataset.certificateJson));
    vm.$mount(element);
  }
};

